import { UserErrorCode } from "../gql/__generated__/graphql"

import type { GraphQLError } from "graphql"

const code_key = "code"

export const getExtensionsCode = (
	graphqlError: GraphQLError
): string | undefined => {
	const extensions = graphqlError.extensions

	if (extensions && typeof extensions[code_key] === "string") {
		const val: string = extensions[code_key]
		return val
	}

	return undefined
}

const invalidIdOrPasswordErrorCodes: UserErrorCode[] = [
	"INVALID_BEAUTY_MERIT_ID_OR_PASSWORD",
	"INVALID_EPARK_ID_OR_PASSWORD",
	"INVALID_KANZASHI_ID_OR_PASSWORD",
	"INVALID_KIREIPASS_CONNECT_ID_OR_PASSWORD",
	"INVALID_MINIMO_ID_OR_PASSWORD",
	"INVALID_PEAK_MANAGER_ID_OR_PASSWORD",
	"INVALID_POSTAS_ID_OR_PASSWORD",
	"INVALID_RAKUTEN_ID_OR_PASSWORD",
	"INVALID_SALONBOARD_ID_OR_PASSWORD",
	"INVALID_SALON_ANSWER_ID_OR_PASSWORD",
	"INVALID_SALON_CONNECT_ID_OR_PASSWORD",
	"INVALID_SALON_SOLUTION_ID_OR_PASSWORD",
	"INVALID_SALORIZA_ID_OR_PASSWORD",
	"INVALID_SALON_CONNECT_ID_OR_PASSWORD",
]

export const isIdOrPasswordErrorCode = (code: string): boolean => {
	// code 文字列が UserErrorCode の union にはない場合、 runtime では単純な文字列比較になるので、
	// false になる。typescript の型チェックを disable するために as を使用。
	return invalidIdOrPasswordErrorCodes.includes(code as UserErrorCode)
}

export const isSalonAnswerForceLogoutErrorCode = (code: string): boolean => {
	return code === "SALON_ANSWER_FORCE_LOGOUT"
}

const isNoApolloAlertExtensionCode = (code: string): boolean => {
	return (
		isIdOrPasswordErrorCode(code) || isSalonAnswerForceLogoutErrorCode(code)
	)
}

export const getAppAlertMessage = (
	graphqlError: GraphQLError
): string | undefined => {
	const code = getExtensionsCode(graphqlError)
	if (!code) {
		return undefined
	}

	if (isNoApolloAlertExtensionCode(code)) {
		return undefined
	}

	return graphqlError.message
}
